import React, { useEffect, useState } from "react";

import { Button, Card, Checkbox, Col, Form, Grid, Input, message, Row, Segmented, Space, theme, Typography } from "antd";
import Logo from "../../../assets/png/logo.png"
import { LockOutlined, UserAddOutlined } from "@ant-design/icons";
import '../../../style/auth.css'
import { adminLogin, parentLogin, staffLogin, } from "../../../service/api";
import { useAuth } from "../../../context/authContext";
import { useNavigate } from "react-router-dom";
import LoginPage from "../../../assets/png/login_side.png"
import { useSecreen } from "../../../context/ScreenContext";

function AddNewProfile() {
    const { login, getUserType, userType, getIsLoggedUser } = useAuth()
    const [isLoading, setIsLoading] = useState(false)
    const [rememberMe, setRememberMe] = useState(false);
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const { width, height } = useSecreen()

    const onFinish = async (values) => {
        const body = {
            email: values.email,
            password: values.password,
        }
        setIsLoading(true);
        
     
        try {
            const res = await adminLogin(body);

            if (res.status === 201) {
                const fetchData = res.data.data;
                console.log("login fetchData", fetchData)
                const token = fetchData?.token;
                if (userType === "Admin") {
                    getIsLoggedUser({ ...fetchData })
                }
                form.resetFields();
                login(token);
                navigate("/admin-dashboard")
            } else {
                console.error("Login failed:", res);
            }
        } catch (error) {
            console.error("Login error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const onFinishFeild = (value) => {
        message.error("All field is required !")
        console.log(value)
    }



    return (
        <section className="login_section">
            <Row>
                <Col sm={24} md={24} lg={16} className="image_section">
                    <img src={LoginPage} />
                    <div className="content_section">
                        {width > 800 ? <Space>
                            {/* <img src={LightLogo} /> */}
                            <h2>Welcome Back, {userType} 👋
                                Sign in to {userType} the dashboard securely.</h2>
                        </Space> :
                            <p>Welcome Back, {userType} 👋
                                Sign in to access the dashboard securely. </p>}
                        <p>Log in to manage your daydace’s daily operations, from child enrollments and staff scheduling to billing and compliance—all in one place.</p>
                    </div>
                </Col>
                <Col sm={24} md={24} lg={8} className="login_form">
                    <Card actions={[<p>Need help? Contact support</p>]}>
                        <div className="login_title gradient-border">
                            <img src={Logo} />
                            <h2>{userType} Login</h2>
                        </div>
                        <div className="login_type">

                        </div>
                        <Form
                            form={form}
                            name="normal_login"
                            initialValues={{
                                email: "owner2@littlestars.com",
                                password: "ashish@123"
                            }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFeild}
                            layout="vertical"
                        >
                            <Form.Item
                                name="email"
                                rules={[
                                    {

                                        required: true,
                                        message: "Please enter email !"
                                    },
                                ]}
                            >
                                <Input
                                    size="large"
                                    prefix={<UserAddOutlined />}
                                    placeholder="Enter  Email"
                                />
                            </Form.Item>
                            <Form.Item
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please enter  your password !",
                                    },
                                ]}
                            >
                                <Input.Password
                                    prefix={<LockOutlined />}
                                    type="password"
                                    placeholder="Enter Password"
                                    size="large"

                                />
                            </Form.Item>
                            <Form.Item name="remember" valuePropName="checked" label={null}>
                                <Checkbox onClick={(value) => setRememberMe(value)}>Remember me</Checkbox>
                            </Form.Item>
                            <Form.Item style={{ marginBottom: "0px" }}>
                                <Button size="large" block="true" loading={isLoading} type="primary" htmlType="submit">
                                    Login
                                </Button>
                                <div className="login_footer">
                                    <Button type="link" >Forget Password</Button>
                                </div>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </section>
    );
}


export default AddNewProfile